import { useCruiseWithRoute } from '../../../hooks/use-cruise';
import { routeCategory } from '../utils/cruise-route';
import { AirplanePolyline } from './airplane-polyline';
import { ExamplePolyline } from './example-polyline';
import { OceanPolyline } from './ocean-polyline';
import { RiverPolyline } from './river-polyline';

/**
 * @returns {React.JSX.Element}
 */
export function PathLayer() {
  const data = useCruiseWithRoute();

  return (
    <>
      {data?.paths.features.map((feature, index) => {
        switch (feature.properties?.category) {
          case routeCategory.river:
            return <RiverPolyline key={index} feature={feature} />;
          case routeCategory.ocean:
            return <OceanPolyline key={index} feature={feature} />;
          case routeCategory.airplane:
            return <AirplanePolyline key={index} feature={feature} />;
          case routeCategory.example:
            return <ExamplePolyline key={index} feature={feature} />;
        }
        return null;
      })}
    </>
  );
}
